import { withInstall } from '@ll-plus/utils'

import TagGroup from './src/tag-group.vue'

export const LlTagGroup = withInstall(TagGroup)
export default LlTagGroup
export * from './src/tag-group'

declare module 'vue' {
  export interface GlobalComponents {
    LlTagGroup: typeof TagGroup
  }
}
